
const summary_cost = (events) => {
    const sum_cost = {client_cost: 0, estro_cost: 0, grant_cost: 0, total: 0};

    events.forEach(event => {
        const sum_client_estro_cost = event.musicians.reduce((m_sum, musician) => {
            m_sum.client_cost += +musician.client_cost
            m_sum.estro_cost += +musician.estro_cost
            return m_sum;
        }, {client_cost: 0, estro_cost: 0});

        sum_cost.client_cost += +sum_client_estro_cost.client_cost
        sum_cost.estro_cost += +sum_client_estro_cost.estro_cost
    })

    sum_cost.grant_cost = sum_cost.estro_cost - sum_cost.client_cost >= 0
        ? sum_cost.estro_cost
        : 0.00

    sum_cost.total =  sum_cost.client_cost >= sum_cost.estro_cost
        ? sum_cost.client_cost
        : sum_cost.estro_cost

    return sum_cost;
}


const calculateTotalCosts = (peoples) => {
    const totals = peoples.reduce((acc, musician) => {
        if (musician.categories && musician.categories.length > 0) {
            musician.categories.forEach(category => {
                acc.totalClientCost += Number(category.client_cost) || 0;
                acc.totalEstroCost += Number(category.estro_cost) || 0;
            });
        }
        return acc;
    }, { totalClientCost: 0, totalEstroCost: 0 });

    return {
        totalClientCost: totals.totalClientCost, //.toFixed(2),
        totalEstroCost: totals.totalEstroCost, //.toFixed(2)
    };
};


export {
    summary_cost,
    calculateTotalCosts
}